// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3t1DI","productName":"Table_productName__3J7ia"};